import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {gsap, TimelineMax} from "gsap";

import {SimplePresentation, SimplePresentationRunner} from "../../core/winpresentation/SimplePresentationRunner";
import {TrueGritAvalancheWinRunner} from "../presentationrunners/maingame/TrueGritAvalancheWinRunner";
import {TrueGritTopReelTransformRunner} from "../presentationrunners/maingame/TrueGritTopReelTransformRunner";
import {TrueGritWildMultiplierRunner} from "../presentationrunners/maingame/TrueGritWildMultiplierRunner";
import {TrueGritTotalWinRunner} from "../presentationrunners/maingame/TrueGritTotalWinRunner";
import {TruGritXNudgePresentation} from "../presentationrunners/maingame/TruGritXNudgePresentation";
import {TrueGritReelSplitRunner} from "../presentationrunners/maingame/TrueGritReelSplitRunner";
import {TrueGritHighLowTransformPresentation} from "../presentationrunners/general/TrueGritHighLowTransformPresentation";
import {TrueGritXWaysRunner} from "../presentationrunners/maingame/TrueGritXWaysRunner";
import {TrueGritTotalBigWinRunner} from "../presentationrunners/general/TrueGritTotalBigWinRunner";
import {TrueGritReelStopAnimationRunner} from "../presentationrunners/maingame/TrueGritReelStopAnimationRunner";
import {TrueGritMaxWinRunner} from "../presentationrunners/general/TrueGritMaxWinRunner";
import {TrueGrit} from "../TrueGrit";
import {TrueGritPlusFSRunner} from "../presentationrunners/maingame/TrueGritPlusFSRunner";
import {TrueGritRevertBotReelSymbols} from "../presentationrunners/general/TrueGritRevertBotReelSymbols";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TrueGritWinPresentation implements FlowStatePresentation {

    private _presentations:SimplePresentation[];
    private _flowStateController:FlowStateController;
    private _bigWinRunner:TrueGritTotalBigWinRunner;
    private _totalWinRunner:TrueGritTotalWinRunner;

    constructor() {
        this._presentations = [
            new TrueGritWildMultiplierRunner(),
            new TrueGritReelStopAnimationRunner(),
            new TrueGritReelSplitRunner(),
            new TrueGritPlusFSRunner(),
            new TrueGritXWaysRunner(),
            new TrueGritTopReelTransformRunner(),
            new TrueGritHighLowTransformPresentation(),
            new TruGritXNudgePresentation(),
            new TrueGritAvalancheWinRunner(),
            new TrueGritRevertBotReelSymbols(),
            this._totalWinRunner = new TrueGritTotalWinRunner(),
            this._bigWinRunner = new TrueGritTotalBigWinRunner(),
            new TrueGritMaxWinRunner()
        ];
    }

    public start(flowStateController:FlowStateController) {
        this._flowStateController = flowStateController;
        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?:Function) => flowStateController.setSkipCallback(callback));

        const tl:TimelineMax = gsap.timeline();
        if(tl.duration() == 0) {
            tl.add(gsap.to(this, {duration : 0.001}));
        }
    }

    public complete() {
        this._flowStateController.finish();
    }

    public setRestores():void{
        this._bigWinRunner.totalBetWays = TrueGrit.model.initData.waysTotalAvalanches;
        this._totalWinRunner.totalBetWays = TrueGrit.model.initData.waysTotalAvalanches;
    }
}